<script>
import Vue from 'vue';
import NavBar from '@backend/part/NavBar.vue';
import SideBar from '@backend/part/SideBar.vue';
import RightSideBar from '@backend/part/RightSideBar.vue';
import GlobalVue from '@helper/Global.vue';
import BoConfig from '@config/BoConfig.js';
import Gen from '@helper/Gen.js';
import Config from '@config/Config.js';

import "@backend/dist/js/perfect-scrollbar.jquery.min.js";
import "@backend/dist/js/waves.js";
import "@backend/dist/js/custom.js";

Vue.component("NavBar",()=>import("@backend/part/NavBar.vue"))
Vue.component("SideBar",()=>import("@backend/part/SideBar.vue"))
Vue.component("RightSideBar",()=>import("@backend/part/RightSideBar.vue"))

export default {
  extends: GlobalVue,
  name:"BoLayout",
  computed:{
    yearcopy(){
      return Gen.yearCopy(Config.yearcopy)
    }
  },
  mounted(){
    $("body").addClass('horizontal-nav')
    this.$set(this.$root, 'base', this)
    // Autologout
    document.addEventListener("mousemove", (e)=>{
      Gen.delay(()=>{
        Page.logout()
      }, this.$root.var.idleTimeout*1000)
    });
  }
}
</script>

<template>
  <div id="main-wrapper">
    <NavBar></NavBar>
    <SideBar></SideBar>
    <div id="page-wrapper">
      <router-view/>
    </div>
    <!-- <RightSideBar></RightSideBar> -->
    <!-- Footer -->
    <footer class="footer text-center inspect"> {{yearcopy}} &copy; PT Bayer Indonesia. All Rights Reserved.</footer>
    <FileManager></FileManager>
    <ImageFilter></ImageFilter>
  </div>
</template>